
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contests",
      function () {
        return require("private-next-pages/contests/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contests"])
      });
    }
  